import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './dialog-confirmation.component.html'
})
export class DialogConfirmationComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public confirm: {title?: string, message: string}) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-confirmation/dialog-confirmation.component.ts